import * as Sentry from "@sentry/react";
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";

const handle = (metric: Metric) => {
  // Attach as a Sentry measurement on the active transaction (if any)
  try {
    Sentry.setMeasurement(metric.name, metric.value, metric.name === "CLS" ? "" : "millisecond");
  } catch {
    /* no-op */
  }
  // Also breadcrumb so it shows up on error events
  Sentry.addBreadcrumb({
    category: "web-vital",
    message: metric.name,
    level: "info",
    data: { value: metric.value, rating: metric.rating, id: metric.id },
  });
};

export const reportWebVitals = () => {
  onCLS(handle);
  onFCP(handle);
  onINP(handle);
  onLCP(handle);
  onTTFB(handle);
};